import { Card, Col } from "react-bootstrap";
import { FaEye, FaGithub } from 'react-icons/fa';
import { AiOutlineFileText } from 'react-icons/ai';
import { useState,useContext } from "react";
import { ShowContext } from "../context/showContext";




export const ProjectCard = ({ title,projectUrl , imgUrl ,description}) => {

const { dispatch ,Isshow ,desProject} = useContext(ShowContext);

const handleclick =(Type)=>{
  if (Type === 'Deploy'){
    window.open(projectUrl.Deployment, '_blank');
  }else {
    window.open(`https://github.com/HamzaShaieb/${projectUrl.github}`, '_blank');
  }


}
  return (
    <> 
    <Col size={12} sm={6} md={4}>
      <div className="proj-imgbx">
        <img src={imgUrl} />
        <div className="proj-txtx">
          <h4>{title}</h4>
          <div className="links">
    <a onClick={()=>handleclick('Deploy')} style={{color:'white',fontSize:'200%',marginRight:'10px'}}  >
        <FaEye />  
     </a>  
      <a onClick={()=>handleclick('Github')} style={{color:'white',fontSize:'200%',marginRight:'10px'}}>
        <FaGithub /> 
      </a>
      <a style={{color:'white',fontSize:'200%',marginRight:'10px'}} onClick={()=>{dispatch({type:"TOGGLE",payload:description}),console.log(desProject)}} >
        <AiOutlineFileText    />  
    </a>
    </div>
        </div>
      </div>
    </Col>
    <div className='d-none'>
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <Card className="text-center">
            <Card.Img variant="top" src="your-image-url.jpg" alt="Card Image" />
            <Card.Body>
              <Card.Title>Card Title</Card.Title>
              <Card.Text>Some example text.</Card.Text>
            </Card.Body>
            <Card.Footer>
              <i className="fas fa-heart"></i>
              <i className="fas fa-comment"></i>
              <i className="fas fa-share"></i>
            </Card.Footer>
          </Card>
        </div>
      </div>
    </div>
    </div>
    </>
  )
}
